import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionChangedEvent, ColGroupDef, ColDef } from '@ag-grid-enterprise/all-modules';
import { DialedDigitExtractionServer } from 'data/dialedDigitExtractionServer/dialedDigitExtractionServer.types';
import CommonGrid from 'shared/commonGrid';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import ActionMenus from 'components/ActionMenus/ActionMenus';

interface Props {
  data: DialedDigitExtractionServer[]
  hasPrivilegeToView: boolean
  hasPrivilegesToCreate: boolean
  hasPrivilegeToDelete: boolean
  noResults: boolean,
  beforeLogout: boolean,
  lastUpdatedAt: Date | undefined,
  columnDefs: (ColGroupDef | ColDef)[],
  selectedDialedDigitExtractionServer: DialedDigitExtractionServer,
  onRefresh: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onCreateNew: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onSelectionChanged: (event: SelectionChangedEvent) => void
  onSelectItemMenuAction: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  onDeleteRow: () => void
  onEdit: () => void
}

const DialedDigitExtractionServerGrid: FunctionComponent<Props> = ({
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  hasPrivilegeToView,
  data = [],
  noResults,
  beforeLogout,
  lastUpdatedAt,
  columnDefs,
  selectedDialedDigitExtractionServer,
  onCreateNew,
  onRefresh,
  onSelectionChanged,
  onSelectItemMenuAction,
  onEdit,
  onDeleteRow,
}: Props) => {

  const { t } = useTranslation();

  return (
    <div className="grid-container" style={{ height: 'inherit' }} data-testid="DdeServerList">
      <CommonGrid
        createNewText={t('dialedDigitExtractionServer.grid.newDdeServer')}
        pagination
        enableBrowserTooltips
        rowSelection={ROWSELECTION.SINGLE}
        hasPrivilegeToCreateNew={hasPrivilegesToCreate}
        hasPrivilegeToDelete={hasPrivilegeToDelete}
        hasPrivilegetoView={hasPrivilegeToView}
        rowData={data}
        noResults={noResults}
        isBeforeLogout={beforeLogout}
        columnDefs={columnDefs}
        handleCreateNew={onCreateNew}
        onRefresh={onRefresh}
        onSelectionChanged={onSelectionChanged}
        onActionMenuItemClick={onSelectItemMenuAction}
        lastUpdatedAt={lastUpdatedAt}
      >
        <ActionMenus
          name={selectedDialedDigitExtractionServer?.msid}
          deleteTitle={t('dialedDigitExtractionServer.deletePopup.title')}
          deleteMessage={t('dialedDigitExtractionServer.deletePopup.message', { msid: selectedDialedDigitExtractionServer?.msid })}
          hasPrivilegesToCreate={hasPrivilegesToCreate}
          hasPrivilegeToDelete={hasPrivilegeToDelete}
          onEdit={onEdit}
          onDelete={onDeleteRow}
        />
      </CommonGrid>
    </div>
  );
};

export default DialedDigitExtractionServerGrid;
